import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { providerInitialValues } from 'components/organisms/forms/providers/ProviderForm';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostProvider } from 'services/providers';
import { IProviderForm } from 'services/providers/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateProvider = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const createProvider = usePostProvider();

  const onCreateProvider = async (values: IProviderForm) => {
    await createProvider.mutateAsync(middleware.provider.formToQuery(values), {
      onError: error => onErrorShowAllErrorsToast(error),
      onSuccess: provider => navigate(`/settings/provider/${provider.id}`),
    });
  };

  return (
    <Form.Provider
      customBackItem={
        <Button type='button' onlyIcon onClick={() => navigate('/settings/provider')}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
        </Button>
      }
      onSubmit={onCreateProvider}
      initialValues={providerInitialValues}
      i18nextPrefix='provider'
    />
  );
};

export default CreateProvider;
